import { ComponentProps } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const Bolt = (props: Omit<ComponentProps<typeof FontAwesomeIcon>, 'icon'>) => (
    <FontAwesomeIcon icon={['fas', 'bolt']} {...props} />
)
